import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { LuMail, LuLock, LuEye, LuEyeOff } from "react-icons/lu";
import { AiOutlineGoogle, AiFillFacebook } from "react-icons/ai";

const Login = () => {
  const navigate = useNavigate();
  const token = Cookies.get("authToken");

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (token !== undefined) {
      navigate("/");
    }
  }, [token, navigate]);

  // Handle input changes
  const handleChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/login`,
        formData
      );

      if (data.status === "success") {
        Cookies.set("authToken", data.data.token, { expires: 1 });
        Cookies.set("userRole", data.data.user.role, { expires: 1 });
        Cookies.set("userPermissions", JSON.stringify(data.data.user.permissions), { expires: 1 });
        localStorage.setItem("userName", data.data.user.name);
        localStorage.setItem("userEmail", data.data.user.email);
        toast.success(data.message);
        navigate("/");
      } else {
        toast.error(data.message || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred during login");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column position-relative h-100 vh-100 page-wrapper align-items-center justify-content-center bg-secondary">

      {/* Home button (optional, keeping from template if needed, or remove) */}

      <div className="container">
        <div className="row justify-content-center">

          {/* Sign in form */}
          <div className="col-md-8 col-lg-6 col-xl-5">
            <div className="card border-0 bg-primary py-md-3 py-lg-4 px-lg-4 px-xl-5" data-bs-theme="dark">
              <div className="card-body">
                <h1 className="py-2 pb-lg-3 text-white">Login</h1>
                <form onSubmit={handleSubmit} autoComplete="off">
                  <div className="pb-3 mb-3">
                    <div className="position-relative">
                      <LuMail className="fs-lg position-absolute top-50 start-0 translate-middle-y text-light opacity-80 ms-3" size={20} />
                      <input
                        className="form-control form-control-lg ps-5"
                        type="email"
                        placeholder="Email address"
                        value={formData.email}
                        onChange={handleChange("email")}
                        required
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <div className="position-relative">
                      <LuLock className="fs-lg position-absolute top-50 start-0 translate-middle-y text-light opacity-80 ms-3" size={20} />
                      <div className="password-toggle">
                        <input
                          className="form-control form-control-lg ps-5"
                          type={showPassword ? "text" : "password"}
                          placeholder="Password"
                          value={formData.password}
                          onChange={handleChange("password")}
                          required
                        />
                        <label
                          className="password-toggle-btn"
                          aria-label="Show/hide password"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer", position: "absolute", right: "1rem", top: "50%", transform: "translateY(-50%)" }}
                        >
                          {showPassword ? <LuEyeOff className="text-light opacity-80" size={20} /> : <LuEye className="text-light opacity-80" size={20} />}
                        </label>
                      </div>
                    </div>
                  </div>

                  <button
                    className="btn btn-lg btn-light w-100 mb-4"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Signing In..." : "Sign in"}
                  </button>


                </form>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Login;
